import { createSlice } from "@reduxjs/toolkit";
import { PartnersState } from "../types/types";
import { fetchOEMGroups, fetchPartners, fetchStores } from "./partners-thunk";
import { ErrorType } from "@/shared/types";

const initialState: PartnersState = {
    partners: [],
    isPartnersLoading: false,
    partnersError: null,
    stores: {},
    storesError: null,
    isStoresLoading: false,
    OEMGroups: [],
    isOEMGroupsLoading: false,
    OEMGroupsError: null
}

const partnersSlice = createSlice({
    name: 'partners',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchPartners.pending, (state) => {
            state.isPartnersLoading = true
            state.partnersError = null
        })
        .addCase(fetchPartners.fulfilled, (state, action) => {
            state.isPartnersLoading = false
            state.partnersError = null
            state.partners = action.payload
        })
        .addCase(fetchPartners.rejected, (state, action) => {
            state.partnersError = action.payload as ErrorType ?? null
            state.isPartnersLoading = false
        })
        .addCase(fetchStores.pending, (state) => {
            state.isStoresLoading = true
            state.storesError = null
        })
        .addCase(fetchStores.fulfilled, (state, action) => {
            state.isStoresLoading = false
            state.storesError = null
            state.stores = action.payload
        })
        .addCase(fetchStores.rejected, (state, action) => {
            state.storesError = action.payload as ErrorType ?? null
            state.isStoresLoading = false
        })
        .addCase(fetchOEMGroups.pending, (state) => {
            state.isOEMGroupsLoading = true
            state.OEMGroupsError = null
        })
        .addCase(fetchOEMGroups.fulfilled, (state, action) => {
            state.isOEMGroupsLoading = false
            state.OEMGroupsError = null
            state.OEMGroups = action.payload
        })
        .addCase(fetchOEMGroups.rejected, (state, action) => {
            state.OEMGroupsError = action.payload as ErrorType ?? null
            state.isOEMGroupsLoading = false
        })
    },
})

export default partnersSlice.reducer

